import React, { useEffect, useState } from 'react';
import WizardServices from './WizardServices';
import cachingMechanisum from '../Common/cachingMechanisum';

export function ContractWizardStatus(MainWizard: any) {

    let [StatusStatement, setStatusStatement] = useState<any>([]);
    let [conAdditional, setcontractAdditional] = useState<any>([]);
    let [AccountStatusName, setAccountStatusName] = useState<any>([]);
    let [contractStatusName, setcontractStatusName] = useState<any>([]);
    let [AccountStatusNameEx, setAccountStatusNameEx] = useState<any>([]);

    useEffect(() => {
        console.log(MainWizard.data.code)

        if (MainWizard.data.code) {

            WizardServices.contractscontractRefNum(MainWizard.data.code).then((value: any) => {
                setcontractAdditional(value)
            })
        }

        var lookUpTypeList = cachingMechanisum.getCachingStorage("lookUpType")
        var contractStatus = lookUpTypeList?.filter((event: any) => (event.lookUpType === "ContractStatus"));
        setcontractStatusName(contractStatus);

        var accountStatus = lookUpTypeList?.filter((event: any) => (event.lookUpType === "accountStatus"));
        setAccountStatusName(accountStatus);

        var accountStatusEx = lookUpTypeList?.filter((event: any) => (event.lookUpType === "accountStatusExt"));
        setAccountStatusNameEx(accountStatusEx);

        var statusStatement = lookUpTypeList?.filter((event: any) => (event.lookUpType === "StatusStatement"));
        setStatusStatement(statusStatement);
    }, []);

    const handleFieldChange = (e: any) => {

        var Field_name = e.target.name;
        var Field_value = e.target.value;
        var Field_type = e.target.type;

        console.log(Field_value)
        console.log(Field_type)
        if (Field_type === "checkbox") {
            Field_value = !Field_value;
        }
        const containsPeriod = Field_name.includes('.');

        let updatedObject = { ...conAdditional };

        if (containsPeriod) {
            const parts = Field_name.split('.');

            let currentLevel = updatedObject;
            for (let i = 0; i < parts.length; i++) {
                if (i < parts.length - 1) {
                    if (!currentLevel[parts[i]]) {
                        currentLevel[parts[i]] = {};
                    }
                    currentLevel = currentLevel[parts[i]];
                } else {
                    currentLevel[parts[i]] = Field_value;
                }
            }
        } else {
            updatedObject[Field_name] = Field_value;
        }

        console.log(updatedObject);
        setcontractAdditional(updatedObject);
    };

    const SaveContract = () => {

    }



    return (

        <>
            <div className="box">

                <div className="box-header">  <h2>Contract Status</h2> </div>

                <div className="box-content allowVscroll">

                    <div className=' ws-12 pull-left'>
                        <div className="form-format">
                            <label className='ws-12'>Contract Status</label>

                            <div className="label-entries">
                                <select name="contractStatus" className='ws-12 full-height' onChange={handleFieldChange} value={conAdditional?.contractStatus ?? ""}>
                                    {contractStatusName.map((values: any) => (
                                        <option value={values.key} label={values.value}>{values.value}</option>
                                    ))}

                                </select>
                            </div>
                        </div>

                        <div className="form-format">
                            <label >Account Status</label>
                            <div className="label-entries">
                                <select name="accountStatus" className='ws-12 full-height' onChange={handleFieldChange} value={conAdditional?.accountStatus ?? ""}>
                                    {AccountStatusName.map((values: any) => (
                                        <option value={values.key} label={values.value}>{values.value}</option>
                                    ))}

                                </select>
                            </div>
                        </div>

                        <div className="form-format">
                            <label >Account Extended Status</label>
                            <div className="label-entries">
                                <select name="accountStatusExt" className='ws-12 full-height' onChange={handleFieldChange} value={conAdditional?.accountStatusExt ?? ""}>
                                    {AccountStatusNameEx.map((values: any) => (
                                        <option value={values.key} label={values.value}>{values.value}</option>
                                    ))}

                                </select>
                            </div>
                        </div>

                        <div className="form-format">
                            <label >Statement Status</label>
                            <div className="label-entries">
                                <select name="statementCategory" className='ws-12 full-height' onChange={handleFieldChange} value={conAdditional?.statementCategory ?? ""}>
                                    {StatusStatement.map((values: any) => (
                                        <option value={values.key} label={values.value}>{values.value}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="form-format">
                            <label >Dimension 1</label>
                            <input className="label-entries" name="dim1" onChange={handleFieldChange} placeholder="Enter Dimension 1" value={conAdditional?.dim1 ? conAdditional.dim1 : ''} />
                        </div>

                        <div className="form-format">
                            <label >Dimension 2</label>
                            <input className="label-entries" name="dim2" onChange={handleFieldChange} placeholder="Enter Dimension 2" value={conAdditional?.dim2 ? conAdditional.dim2 : ''} />
                        </div>

                        <div className="form-format">
                            <label >Dimension 3</label>
                            <input className="label-entries" name="dim3" onChange={handleFieldChange} placeholder="Enter Dimension 3" value={conAdditional?.dim3 ? conAdditional.dim3 : ''} />
                        </div>
                    </div>
                </div>

                <div className='ws-2 pull-right'>
                    {<a className="icon-btn edit width90 height35" onClick={SaveContract}>Save</a>}
                </div>
            </div>

        </>
    );
}